export class CostRecordMetadata {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "CostRecordMetadataType",
            "format": ""
        },
        {
            "name": "dataTransfer",
            "baseName": "dataTransfer",
            "type": "CostRecordMetadataDataTransfer",
            "format": ""
        },
        {
            "name": "classification",
            "baseName": "classification",
            "type": "any",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostRecordMetadata.attributeTypeMap;
    }
    constructor() {
    }
}
